import SecureRouteContainer from './containers/SecureRouteContainer'

export default SecureRouteContainer
